import { call, put, select } from 'redux-saga/effects';
import FrontSonda from '@gcloud-npm/utils.monitoring.front-sonda';
import { isR2RAvailableToPurchase as isR2RAvailableToPurchaseBit } from '../bitSagas/isR2RAvailableToPurchase';
import { getSignatureOTP as getSignatureOTPBit } from '../bitSagas/getSignatureOTP';
import { getDate as getDateBit } from '../bitSagas/getDate';
import { actions as loaderControlActions } from '../reducers/loaderControl';
import { actions as apisNeedsActions } from '../reducers/apisNeeds';
import { actions as uiNeedsActions } from '../reducers/uiNeeds';
import { actions as offerActions } from '../reducers/offer';
import { getHandledErrors } from '../errorManagement/handledErrors';
import { megaMinderStatus } from '../minder/MegaMinder/megaMinderStatus';
import { STRING_KEYS } from '../localizedStrings';
import { areThereProductOfferingTypesIntoOfferArray, DEVICE_VALUES, PRODUCT_OFFERING_TYPES } from '../utils/catalog';

const offerStore = state => state.offer;
const contextStore = state => state.context.data;
const localizedStringsStore = state => state.localizedStrings;
const flowStore = state => state.flow;
const apisNeedsStore = state => state.apiNeeds;
const getErrorManagement = state => state.errorManagement;

const getIncludedR2RInfo = (products) => {
  const r2r = {
    name: null,
    startDate: null,
  };

  products.forEach(product => {
    const isIncludedR2R = areThereProductOfferingTypesIntoOfferArray(product.productOfferingTypes, PRODUCT_OFFERING_TYPES.INCLUDED_R2R);

    if (isIncludedR2R) {
      const { name, startDate } = product;

      if (name) {
        r2r.name = name.replace('Dispositivo principal: ', '');
      }

      if (startDate) {
        const date = new Date(startDate);
        r2r.startDate = date.toLocaleDateString('es-ES', {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit'
        });
      }
    }
  });

  return r2r;
}

export function* isR2RAvailableToPurchase(input) {
  const offer = yield select(offerStore);
  const { r2rType } = offer;
  const context = yield select(contextStore);
  const flow = yield select(flowStore);
  const { isSelfEmployedFlow, flowName: flowId } = flow.flowJson;
  const { showError, normalizeHttpErrors } = input;

  const handledErrors = getHandledErrors(flowId, context.userType, isSelfEmployedFlow);
  if (r2rType !== DEVICE_VALUES.INCLUDED && r2rType !== DEVICE_VALUES.ADDITIONAL) {
    yield put(showError(handledErrors.BUSINESS_ERRORS.INCORRECT_PARAMS));
    return megaMinderStatus.KO;
  }
  const reduxUpdate = {
    errorUpdate: showError,
  };
  const isR2RAvailableToPurchaseParams = {
    reduxUpdate,
    normalizeHttpErrors,
    context,
  };

  let response = null;
  try {
    response = yield call(isR2RAvailableToPurchaseBit, isR2RAvailableToPurchaseParams);
    const { incluido, adicional } = { ...response };
    switch (r2rType) {
      case 'incluido':
        if (incluido.availableForPurchase) {
          if(incluido.alreadyRedeemed){
            yield put(offerActions.saveR2RSubtype(2));
          }
          return megaMinderStatus.OK;
        }
        if (incluido.alreadyRedeemed && !incluido.availableForPurchase) {
          const { deviceInfo, myProductsInfo } = yield select(apisNeedsStore);
          const { rawData } = myProductsInfo;

          const includedR2RInfo = getIncludedR2RInfo(rawData);


          const { fileUrl, name } = deviceInfo;
          const newErrorToPrint = handledErrors.BUSINESS_ERRORS.PRODUCT_REGISTERED;

          if (fileUrl) {
            newErrorToPrint.errorInfo.buttons[0].link = `https://app.movistar.es${fileUrl}?origin=pyp-continuar`;
          }
          if (name) {
            newErrorToPrint.errorInfo.title = newErrorToPrint.errorInfo.title.replace('{device}', name);
            newErrorToPrint.errorInfo.msg[2] = newErrorToPrint.errorInfo.msg[2].replace('{device}', name);
          } else {
            newErrorToPrint.errorInfo.title = newErrorToPrint.errorInfo.title.replace('{device}', 'dispositivo');
            newErrorToPrint.errorInfo.msg[2] = newErrorToPrint.errorInfo.msg[2].replace('{device}', '');
            
          }

          if (includedR2RInfo?.name && includedR2RInfo?.startDate) {
            newErrorToPrint.errorInfo.msg[1] = newErrorToPrint.errorInfo.msg[1].replace('{includedR2RInfo}', `${includedR2RInfo.name} desde el ${includedR2RInfo.startDate}.`);
          } else {
            newErrorToPrint.errorInfo.msg[1] = newErrorToPrint.errorInfo.msg[1].replace('{includedR2RInfo}', '');
          }

          if (showError) {
            yield put(
              showError(handledErrors.BUSINESS_ERRORS.PRODUCT_REGISTERED),
            );
          }
          return megaMinderStatus.KO;
        }
        if (!incluido.availableForPurchase) {
          if (showError) {
            yield put(
              showError(handledErrors.BUSINESS_ERRORS.NON_FUSION_CURRENT_PORTFOLIO),
            );
          }
          return megaMinderStatus.KO;
        }
        break;
      case 'adicional':
        if (!incluido.alreadyRedeemed && incluido.availableForPurchase) {
          if (showError) {
            yield put(
              showError(
                handledErrors.BUSINESS_ERRORS.ADDITIONAL_R2R_ERROR,
              ),
            );
          }
          return megaMinderStatus.KO;
        }
        if (adicional.alreadyRedeemed && !adicional.availableForPurchase) {
          if (showError) {
            yield put(
              showError(
                handledErrors.BUSINESS_ERRORS.MAX_R2R_REACHED,
              ),
            );
          }
          return megaMinderStatus.KO;
        }
        if (!adicional.availableForPurchase) {
          if (showError) {
            yield put(
              showError(
                handledErrors.BUSINESS_ERRORS.NON_FUSION_CURRENT_PORTFOLIO,
              ),
            );
          }
          return megaMinderStatus.KO;
        }
        return megaMinderStatus.OK;
      default:
        return megaMinderStatus.KO;
    }
    return megaMinderStatus.KO;
  } catch (e) {
    return megaMinderStatus.KO;
  }
}

export function* getSignatureOTP(input) {
  const context = yield select(contextStore);
  const apiNeeds = yield select(apisNeedsStore);

  const { phoneNumberOTP, cqId } = apiNeeds;

  const {
    showError,
    normalizeHttpErrors,
  } = input;

  const reduxUpdate = {
    errorUpdate: showError,
    successUpdate: uiNeedsActions.setSignatureOTPUrl,
  };

  const apiParams = {
    reduxUpdate,
    normalizeHttpErrors,
    phoneNumberOTP,
    cqId,
    context,
  };

  const { localizedStrings } = yield select(localizedStringsStore);
  yield put(
    loaderControlActions.setLoaderState({
      loading: true,
      loadingText: localizedStrings[STRING_KEYS.waitingPageTexts.getSignatureOTP],
    }),
  );
  let response = null;
  try {
    response = yield call(getSignatureOTPBit, apiParams);
    if (!response) {
      const { handledErrors } = yield select(getErrorManagement);
      yield put(showError(handledErrors.BUSINESS_ERRORS.WITHOUT_URL_TO_SIGN));
      const frontSonda = new FrontSonda({
        processName: 'getSignatureOTP',
        filePath: 'bitSagas/getSignatureOTP',
      });
      frontSonda.severalMessage({
        info: `No signature url received. CQ:${cqId}. Params: ${window.location.search}`,
      });
    }
    return response;
  } catch (e) {
    return null;
  }
}


export function* getDate(input) {
  const context = yield select(contextStore);

  const {
    showError,
    normalizeHttpErrors,
  } = input;

  const reduxUpdate = {
    errorUpdate: showError,
    successUpdate: apisNeedsActions.setCurrentDate,
  };

  const apiParams = {
    reduxUpdate,
    normalizeHttpErrors,
    context,
  };

  let response = null;
  try {
    response = yield call(getDateBit, apiParams);
    return response;
  } catch (e) {
    return null;
  }
}
